<script>
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';
    import Mobilebtn from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let backClr;
    let text1;
    let text2;
    let text3;
    let mainImg;
    export let scrollPointers;
    export let updatedValue;
    
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            scrollPointers,
            [
                {scrollValue: 4, duration: 1},
                {
                    scrollValue: 5,
                    duration: 1,
                    onUpdate: () => {
                        if (scrollPointers.scrollValue != 4 && scrollPointers.scrollValue != 5) {
                            updatedValue = scrollPointers.scrollValue;
                        }
                    },
                },
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            backClr,
            [
                {background: 'white', duration: 3},
                {background: '#2C1302', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text1,
            [
                {bottom: 'max(81.785vw,37.86vh)', duration: 3},
                {bottom: 'max(22.43vw,10.384vh)', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text2,
            [
                {left: '8.178vw', y: '0vw', duration: 3},
                {left: '0vw', y: '0vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text3,
            [
                {top: '-max(13vw,6.018vh)', duration: 3},
                {top: 'max(33.879vw,15.684vh)', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            mainImg,
            [
                {left: '0vw', scale: 1, duration: 3},
                {left: '-0vw', scale: 1.3, duration: 3},
            ],
            3,
        );
    }
</script>

<section bind:this={main}>
    <div class="navbar">
        <MobileNavbar />
    </div>
    <div class="main-div"  bind:this={backClr}>
        <div class="text"  bind:this={text3} ><p>4</p></div>
        <div class="main-img" bind:this={mainImg}>
            <img
                src="images/Artist/ArtistMobile/character.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="title" bind:this={text1}>
            <p bind:this={text2}>Character, Virtual MuA & Animation Artists</p>
            <div class="descrip">
                <p>
                    We’re building the future where you will build armies with
                    each soldier having unique personal traits rather than one
                    character a week.
                </p>
                <p>
                    Join us for a sneak peek on what it is like and while you’re
                    there, show off your latest creations and voice your opinion
                    on what you would like to see added to that future.
                </p>
            </div>
        </div>
        <div class="btn">
            <Mobilebtn bgcolor="#D8490B" width="56.308vw" state = "Artists & Musicians"/>
        </div>
    </div>
</section>

<style>
    .navbar {
        position: fixed;
        width: 100%;
        z-index: 3;
    }
    .main-div {
        width: 100%;
        height: max(216.355vw,100vh);
        position: relative;
        overflow: hidden;
        background-color: #2C1302;
    }
    .main-img {
        width: 100%;
        height: max(160.748vw,74.42vh);
        position: absolute;
        bottom: 0vw;
        left: -28vw;
        scale: 1.3;
    }
    .title {
        width: 89vw;
        position: absolute;
        left: 7.243vw;
        bottom: max(81.682vw,37.8157vh);
        z-index: 2;
    }
    .title p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 7.009vw;
        text-transform: uppercase;
        color: #000000;
    }
    .descrip {
        width: fit-content;
        float: right;
    }
    .descrip p:nth-child(1) {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 600;
        font-size: 2.804vw;
        width: 44.86vw;
        text-transform: capitalize;
        color: #000000;
        letter-spacing: 6%;
        line-height: 3.925vw;
    }
    .descrip p:nth-child(2) {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        width: 44.86vw;
        text-transform: capitalize;
        color: #000000;
        letter-spacing: 6%;
        line-height: 3.925vw;
    }
    .btn {
        position: absolute;
        bottom: max(6.9226vh,14.953vw);
        left: 21.495vw;
    }
    .text {
        position: absolute;
        right: 10.196vw;
        bottom: max(88.551vw,40.995vh);
        z-index: 1;
    }

    .text p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 140.187vw;
        line-height: 100%;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(244, 238, 236, 0.7);
    }
</style>
